const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  dateFrom: (lambdaParameter, value) => {
    if (typeof value === 'undefined') {
      return `true`
    }
    if (typeof value === 'string') {
      return `${lambdaParameter}.CreatedAt > DateTime.Parse("${value}")`
    }
    return `true`
  },
  dateTo: (lambdaParameter, value) => {
    if (typeof value === 'undefined') {
      return `true`
    }
    if (typeof value === 'string') {
      return `${lambdaParameter}.CreatedAt < DateTime.Parse("${value}")`
    }
    return `true`
  },
  description: (lambdaParameter, value) =>
    `${lambdaParameter}.Description.Contains("${value}")`,
  doorId: (lambdaParameter, value) =>
    `(${lambdaParameter} as DoorLog).DoorId.Equals(${value})`,
  notified: (lambdaParameter, value) => `${lambdaParameter}.Notified==${value}`,
  type: (lambdaParameter, value) => `${lambdaParameter} is ${value}`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
